<template>
    <div class="wrapper wrapper-content animated fadeInRight">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox float-e-margins">
                    <div class="ibox-title">
                        <h5>{{ isEditing ? 'Editar' : 'Nova' }} Não Conformidade</h5>
                        <div class="ibox-tools">
                            <router-link :to="'/nonconformities'" class="btn btn-primary btn-xs">
                                Voltar
                            </router-link>
                        </div>
                    </div>
                    <div class="ibox-content">
                        <form @submit.prevent="saveNonconformity" enctype="multipart/form-data">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Unidade *</label>
                                        <select v-model="form.branch_id" class="form-control" required>
                                            <option value="">Selecione uma unidade</option>
                                            <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                                                {{ branch.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Área *</label>
                                        <select v-model="form.team_id" class="form-control" required>
                                            <option value="">Selecione uma área</option>
                                            <option v-for="team in teams" :key="team.id" :value="team.id">
                                                {{ team.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Checklist</label>
                                        <select v-model="form.checklist_id" class="form-control" @change="loadChecklistItems">
                                            <option value="">Selecione um checklist</option>
                                            <option v-for="checklist in checklists" :key="checklist.id" :value="checklist.id">
                                                {{ checklist.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Item do Checklist</label>
                                        <select v-model="form.checklist_item_id" class="form-control" :disabled="!form.checklist_id">
                                            <option value="">Selecione um item</option>
                                            <option v-for="item in checklistItems" :key="item.id" :value="item.id">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Observação *</label>
                                        <textarea v-model="form.observation" class="form-control" rows="4" required></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="!isEditing">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Fotos</label>
                                        <div class="file-upload">
                                            <input type="file" ref="photos" multiple @change="handleFileUpload" accept="image/*" class="form-control">
                                        </div>
                                        <small class="text-muted">Você pode selecionar múltiplas fotos.</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="photoPreview.length > 0">
                                <div class="col-md-12">
                                    <h4>Pré-visualização das fotos</h4>
                                    <div class="row">
                                        <div class="col-md-3" v-for="(photo, index) in photoPreview" :key="index">
                                            <div class="ibox">
                                                <div class="ibox-content product-box">
                                                    <div class="product-imitation">
                                                        <img :src="photo.url" class="img-responsive" alt="Foto da não conformidade">
                                                    </div>
                                                    <div class="product-desc">
                                                        <div class="form-group">
                                                            <input type="text" v-model="photo.description" class="form-control" placeholder="Descrição da foto">
                                                        </div>
                                                        <div class="m-t text-right">
                                                            <button type="button" class="btn btn-xs btn-danger" @click="removePhoto(index)">
                                                                <i class="fa fa-trash"></i> Remover
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <button type="submit" class="btn btn-primary" :disabled="loading">
                                            <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                                            {{ isEditing ? 'Atualizar' : 'Salvar' }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isEditing: false,
            loading: false,
            form: {
                branch_id: '',
                team_id: '',
                checklist_id: '',
                checklist_item_id: '',
                observation: ''
            },
            branches: [],
            teams: [],
            checklists: [],
            checklistItems: [],
            photos: [],
            photoPreview: []
        };
    },
    created() {
        this.isEditing = this.$route.name === 'nonconformities.edit';
        this.loadBranches();
        this.loadTeams();
        this.loadChecklists();
        
        if (this.isEditing) {
            this.loadNonconformity();
        }
    },
    methods: {
        loadBranches() {
            this.$http.get('branches').then(response => {
                this.branches = response.data;
            }).catch(error => {
                this.$toastr.e("Erro ao carregar unidades.");
            });
        },
        loadTeams() {
            this.$http.get('teams').then(response => {
                this.teams = response.data;
            }).catch(error => {
                this.$toastr.e("Erro ao carregar áreas.");
            });
        },
        loadChecklists() {
            this.$http.get('checklists').then(response => {
                this.checklists = response.data;
            }).catch(error => {
                this.$toastr.e("Erro ao carregar checklists.");
            });
        },
        loadChecklistItems() {
            if (!this.form.checklist_id) {
                this.checklistItems = [];
                this.form.checklist_item_id = '';
                return;
            }
            
            this.$http.get(`checklists/${this.form.checklist_id}/items`).then(response => {
                this.checklistItems = response.data;
            }).catch(error => {
                this.$toastr.e("Erro ao carregar itens do checklist.");
            });
        },
        loadNonconformity() {
            this.loading = true;
            const api = this.$store.state.api + 'nonconformities/' + this.$route.params.id;
            this.$http.get(api, {
                params: {
                    with: ['branch', 'team', 'user', 'checklist', 'checklist_item', 'photos']
                }
            }).then(response => {
                const nonconformity = response.data.data[0];
                this.form = {
                    branch_id: nonconformity.branch_id,
                    team_id: nonconformity.team_id,
                    checklist_id: nonconformity.checklist_id,
                    checklist_item_id: nonconformity.checklist_item_id,
                    observation: nonconformity.observation
                };
                
                // Carregar fotos existentes para visualização
                if (nonconformity.photos && nonconformity.photos.length > 0) {
                    nonconformity.photos.forEach(photo => {
                        this.photoPreview.push({
                            url: this.getPhotoUrl(photo.photo_path),
                            id: photo.id,
                            description: photo.description || '',
                            existing: true
                        });
                    });
                }
                
                if (this.form.checklist_id) {
                    this.loadChecklistItems();
                }
                
                this.loading = false;
            }).catch(error => {
                this.$toastr.e("Erro ao carregar dados da não conformidade.");
                this.loading = false;
            });
        },
        getPhotoUrl(path) {
            // Extrair o nome do arquivo do caminho completo
            const filename = path.split('/').pop();
            // Usar a nova rota para acessar a foto
            const tenant = window.location.pathname.split('/')[1]; // Obtém o tenant da URL atual
            return `/${tenant}/api/v1/nonconformity_photos/${filename}`;
        },
        handleFileUpload(event) {
            const files = event.target.files;
            if (!files.length) return;
            
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if (!file.type.match('image.*')) continue;
                
                this.photos.push(file);
                
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.photoPreview.push({
                        url: e.target.result,
                        file: file,
                        description: ''
                    });
                };
                reader.readAsDataURL(file);
            }
            
            // Limpar o input para permitir selecionar os mesmos arquivos novamente
            this.$refs.photos.value = '';
        },
        removePhoto(index) {
            const photo = this.photoPreview[index];
            
            // Se for uma foto existente e estamos no modo de edição, remover do servidor
            if (this.isEditing && photo.existing) {
                if (confirm('Tem certeza que deseja remover esta foto?')) {
                    this.loading = true;
                    const api = this.$store.state.api + `nonconformities/${this.$route.params.id}/photos/${photo.id}`;
                    
                    this.$http.delete(api)
                        .then(response => {
                            this.$toastr.s('Foto removida com sucesso!');
                            this.photoPreview.splice(index, 1);
                            this.loading = false;
                        })
                        .catch(error => {
                            this.$toastr.e('Erro ao remover a foto.');
                            this.loading = false;
                        });
                }
            } else {
                // Se for uma foto nova, apenas remover da pré-visualização
                this.photoPreview.splice(index, 1);
            }
        },
        saveNonconformity() {
            this.loading = true;
            
            const formData = new FormData();
            formData.append('branch_id', this.form.branch_id);
            formData.append('team_id', this.form.team_id);
            
            if (this.form.checklist_id) {
                formData.append('checklist_id', this.form.checklist_id);
            }
            
            if (this.form.checklist_item_id) {
                formData.append('checklist_item_id', this.form.checklist_item_id);
            }
            
            formData.append('observation', this.form.observation);
            
            // Adicionar fotos ao FormData
            let photoIndex = 0;
            
            // Adicionar fotos existentes (apenas na edição)
            if (this.isEditing) {
                this.photoPreview.forEach((item) => {
                    if (item.existing) {
                        formData.append(`existing_photos[${photoIndex}][id]`, item.id);
                        formData.append(`existing_photos[${photoIndex}][description]`, item.description);
                        photoIndex++;
                    }
                });
            }
            
            // Adicionar novas fotos
            photoIndex = 0;
            this.photoPreview.forEach((item) => {
                if (!item.existing && item.file) {
                    formData.append(`photos[${photoIndex}][photo]`, item.file);
                    formData.append(`photos[${photoIndex}][description]`, item.description);
                    photoIndex++;
                }
            });
            
            const api = this.$store.state.api + (this.isEditing ? `nonconformities/${this.$route.params.id}` : 'nonconformities');
            const method = this.isEditing ? 'put' : 'post';
            
            this.$http[method](api, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                this.$toastr.s(`Não conformidade ${this.isEditing ? 'atualizada' : 'criada'} com sucesso!`);
                this.$router.push('/nonconformities');
            }).catch(error => {
                this.loading = false;
                if (error.response && error.response.data && error.response.data.errors) {
                    const errors = error.response.data.errors;
                    for (const key in errors) {
                        this.$toastr.e(errors[key][0]);
                    }
                } else {
                    this.$toastr.e(`Erro ao ${this.isEditing ? 'atualizar' : 'criar'} não conformidade.`);
                }
            });
        }
    }
};
</script>

<style scoped>
.product-imitation {
    padding: 10px;
    text-align: center;
}

.product-imitation img {
    max-width: 100%;
    max-height: 150px;
    object-fit: cover;
}

.product-desc {
    padding: 10px;
    position: relative;
}
</style> 


// WEBPACK FOOTER //
// src/components/Nonconformity/Form.vue